import { StyleSheet } from "@react-pdf/renderer";

export const quoteSummaryStyles = StyleSheet.create({
    page: {
        padding: "10px 20px",
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: "#ffffff",
    },
    // header
    header: {
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 'bold',
    },
    // table body 
    table: {
        marginTop: 5,
        marginBottom: 5,
        border: "1px solid #63707E",
    },
    tableRow: {
        flexDirection: "row",
    },
    tableHeadCol:
    {
        borderWidth: 0,
        padding: "3px 0 2px 2px",
        textAlign: "center",
        width: "100px"
    },
    tableCol: {
        width: "100%",
        borderWidth: 0,
        padding: "3px 0 3px 2px",
        textAlign: "center",
    },
    tableHeadCell: {
        textAlign: "left",
        fontSize: 9,
        color: '#63707E',
    },
    tableColonCell: {
        textAlign: "left",
        fontSize: 9,
        color: '#000811',
        padding: "3px 0 2px 2px",
    },
    tableCell: {
        textAlign: "left",
        fontSize: 9,
        color: '#000811',
        paddingLeft: "5px",
    },
    // project row
    projectTableRow: {
        flexDirection: "row",
        borderTop: "1px solid #63707E",
    },
    tableProjectCol: {
        width: "100%",
        borderWidth: 0,
        padding: "2px 0 2px 2px",
        textAlign: "center",
    },
    tableProjectRow: {
        flexDirection: "row",
    },
    projectTableHeadCol:
    {
        width: "87px",
        borderWidth: 0,
        padding: "2px 0 3px 2px",
        textAlign: "center",
    },
    tableHeadProjectCell: {
        textAlign: "left",
        fontSize: 9,
        color: '#63707E',
    },
    tableColonProjectCell: {
        textAlign: "left",
        fontSize: 9,
        color: '#000811',
        padding: "2px 0 2px 0",
    },
    tableProjectCell: {
        textAlign: "left",
        fontSize: 9,
        color: '#000811',
        paddingLeft: "5px",
    },
    proposalText: {
        fontSize: 9,
        marginTop: 5,
        marginBottom: 10,
    },
    // model table
    modelProductListDetailTable: {
        display: "table",
        width: "auto",
        fontSize: "9px",
        textAlign: "center",
        borderWidth: "1px solid #63707E",
    },
    modelProductListDetailRow: {
        flexDirection: "row",
    },
    modelProductListDetailHeadColumn: {
        width: "30px",
        borderRight: "1px solid #63707E",
        borderBottom: "1px solid #63707E",
        backgroundColor: "#edf2f6",
        color: "#000811"
    },
    modelProductListDetailTableHeadCell: {
        padding: "5px",
        fontWeight: 700,
    },
    modelProductListDetailTagRefHeadColumn: {
        width: "250px",
        borderRight: "1px solid #63707E",
        borderBottom: "1px solid #63707E",
        backgroundColor: "#edf2f6",
        color: "#000811"
    },
    modelProductListDetailSizeHeadColumn: {
        width: "180px",
        borderRight: "1px solid #63707E",
        borderBottom: "1px solid #63707E",
        backgroundColor: "#edf2f6",
        color: "#000811"
    },
    modelProductListDetailQtyHeadColumn: {
        width: "50px",
        borderRight: "1px solid #63707E",
        borderBottom: "1px solid #63707E",
        backgroundColor: "#edf2f6",
        color: "#000811"
    },
    modelProductListDetailUnitHeadColumn: {
        width: "100px",
        borderRight: 0,
        borderBottom: "1px solid #63707E",
        backgroundColor: "#edf2f6",
        color: "#000811",
        textAlign: "right"
    },
    modelProductListDetailsColumn: {
        width: "30px",
        borderRight: "1px solid #63707E",
        borderBottom: 0,
    },
    modelProductListDetailTableCell: {
        padding: "5px",
    },
    modelProductListDetailTagRefColumn: {
        width: "250px",
        borderRight: "1px solid #63707E",
        borderBottom: 0,
    },
    modelProductListDetailModelColumn: {
        width: "180px",
        borderRight: "1px solid #63707E",
        borderBottom: 0,
    },
    modelProductListDetailQtyColumn: {
        width: "50px",
        borderRight: "1px solid #63707E",
        borderBottom: 0,
    },
    modelProductListDetailTotalColumn: {
        width: "100px",
        borderRight: 0,
        borderBottom: 0,
        textAlign: "right"
    },
    // details table
    detailsTable: {
        display: "table",
        width: "auto",
        textAlign: "right",
        marginTop: "5px",
        border: "1px solid #63707E",
    },
    detailsTableRow: {
        flexDirection: "row",
    },
    detailsTableColumn: {
        width: "100%",
        borderTop: "0px",
    },
    detailsTableCell: {
        fontSize: 9,
        border: 0,
        paddingRight: "10px",
        paddingBottom: "10px",
    },
    detailsQarTableColumn: {
        width: "10%",
        border: 0,
    },
    detailsQarTableCell: {
        fontSize: 9,
        border: 0,
        paddingRight: "10px",
        color: '#63707E'
    },
    detailsPriceTableColumn: {
        width: "15%",
        border: 0,
        textAlign: 'right'
    },
    detailsPriceTableCell: {
        fontSize: 9,
        textAlign: 'right',
        paddingRight: "10px",
        border: 0
    },
    totalDetailsTableRow: {
        flexDirection: "row",
        alignItems:"center"
    },
    totalDetailsTableColumn: {
        width: "30%",
        borderTop: "0px",
        textAlign: "left"
    },
    totalDetailsQarTableColumn: {
        width: "10%",
        border: 0,
    },
    totalDetailsPriceTableColumn: {
        width: "75%",
        border: 0,
    },
    totalDetailsFullPriceTableColumn: {
        width: "100%",
        border: 0,
    },
    totalDetailsPriceTableCell: {
        fontSize: 9,
        textAlign: 'left',
        paddingRight: "10px",
        border: 0
    },
    grandTotalDetailsTableColumn: {
        width: "26%",
        borderTop: "0px",
    },
    totalDetailsTableCell: {
        fontSize: 9,
        border: 0,
        paddingRight: "10px",
    },
    grandTotalDetailsQarTableColumn: {
        width: "13%",
        border: 0,
    },
    grandTotalDetailsPriceTableColumn: {
        width: "20%",
        border: 0,
    },
    // net total
    detailsNetTotalTableColumn: {
        width: "81%",
        borderRight: "1px solid #63707E",
        borderTop: "1px solid #63707E",
        borderBottom: 0,
        borderLeft: 0,
    },
    detailsQarNetTotalTableColumn: {
        width: "37%",
        borderTop: "1px solid #63707E",
        borderBottom: 0,
    },
    detailsPriceNetTotalTableColumn: {
        width: "40%",
        textAlign: 'right',
        borderTop: "1px solid #63707E",
        borderLeft: "1px solid #63707E",
        borderRight: 0,
        borderBottom: 0,
    },
    // terms & condition
    termsandConditionTable: {
        display: "table",
        paddingRight: "15px",
        width: "auto",
        marginTop: 10,
    },
    termsandConditionTableRow: {
        flexDirection: "row",
        marginRight: 50,
    },
    termsandConditionTableLabelCell: {
        fontSize: 9,
        textAlign: "left",
        lineHeight: 1.5,
        color: '#63707E'
    },
    termsandConditionTableHeadingCell: {
        fontSize: 10,
        textAlign: "left",
        lineHeight: 1.5,
        fontWeight: 700,
        color: '#000811',
        width: "100px",
        textDecoration: "underline",
    },
    termsandConditionTableHeadCell: {
        fontSize: 9,
        textAlign: "left",
        lineHeight: 1.5,
        fontWeight: 700,
        color: '#000811',
        width: "100px"
    },
    termsandConditionTableCell: {
        fontSize: 9,
        textAlign: "left",
        lineHeight: 1.5,
        fontWeight: 700,
        color: '#000811',
        paddingLeft: "10px",
        width: "90%",
    },
    termsandConditionColonTableCell: {
        fontSize: 9,
        textAlign: "left",
        lineHeight: 1.5,
        fontWeight: 700,
        color: '#000811'
    },
    signatureTableRow: {
        flexDirection: "row",
    },
    signatureTableCell: {
        fontSize: 8,
        paddingTop: "20px"
    },
    // footer
    footer: {
        textAlign: 'center',
        fontSize: 12,
    },
    declarationTable: {
        paddingRight: "15px",
        width: "auto",
        marginTop: 10,
    },
    declarationTableRow: {
        flexDirection: "row",
        marginRight: 50,
    },
    italicFooterText: {
        fontSize: 9,
    },
    boldFooterText: {
        paddingTop: 10,
        fontSize: 9,
        fontWeight: 700,
    },
    test: {
        marginTop: "40px",
    }
});